import React, { Fragment, useContext, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import moment from 'moment';

import { Loader } from '@squirrellearningltd/go-pupil-components';
import { BOOK_STATUS } from '@squirrellearningltd/go-shared-utils';
import { Link } from '@reach/router';
import { MAIN_DASHBOARD_QUERY } from './services/graphql';
import { AuthContext } from '../../services/user/AuthProvider';
import styles from './Dashboard.module.scss';
import Writing from './scenes/Writing';
import boomer from '../../images/loader-boomer.png';
import ispLogo from '../../images/isp_logo.png';
import { FILTERED_TEMPLATES } from './services/graphql';

// New Dashboard
import boomerAvatarBackground from '../../images/new-dashboard/boomer-avatar-background.png';
import gem from '../../images/new-dashboard/gem.svg';
import progressBooksCompleted from '../../images/new-dashboard/progress-books-completed.svg';
import progressWinningChapters from '../../images/new-dashboard/progress-winning-chapters.svg';
import progressGems from '../../images/new-dashboard/progress-gems.svg';
import classProjects from '../../images/new-dashboard/class-projects.svg';
import navigationIcon from '../../images/new-dashboard/navigation-icon.svg';

import { ProgressItems } from '@squirrellearningltd/go-pupil-components';
import ClassProjects from './components/class-project/ClassProjects';
import PublishedBooks from './components/published-books/PublishedBooks';

const Dashboard = () => {
    const { data, error, loading } = useQuery(MAIN_DASHBOARD_QUERY, {
        fetchPolicy: 'cache-and-network'
    });
    const { data: data2, loading: loading2, error: error2 } = useQuery(FILTERED_TEMPLATES, {
        variables: {
            isIspChoice: true
        }
    });

    const { currentUser: user } = useContext(AuthContext);

    const getBooks = (selectedCriteria) => {
        const filteredBooks = [];
        const books = data?.currentStudent?.books;

        if (!books) {
            return filteredBooks;
        }

        if (selectedCriteria === 'classProject') {
            books.forEach(book => {
                if (book.status < BOOK_STATUS.completed || (book.completedAt && moment(book.completedAt).isBefore(moment().subtract(2, 'days').startOf('day')))) {
                    filteredBooks.push(book);
                }
            })
        }
        if (selectedCriteria === 'published') {
            books.forEach(book => {
                if (book.status >= BOOK_STATUS.completed && !book.classPack?.isWritingActivity) {
                    filteredBooks.push(book);
                }
            })
        }

        return filteredBooks;
    }

    const isNewDashboard = true;

    if (data && data.currentStudent && data.currentStudent.books && data2?.filteredBookTemplates) {
        return (
            <>
                <div className={styles.dashboardContainer}>
                    <div className={styles.boomerDataProgress}>
                        <div className={styles.boomerInfoWrapper}>
                            <div
                                className={styles.boomerAvatar}
                                style={{
                                    backgroundImage: `url(${JSON.stringify(data.currentStudent.backgroundImageUrl || boomerAvatarBackground)})`,

                                }}>
                                <img src={data.currentStudent.boomerAvatarUrl ? data.currentStudent.boomerAvatarUrl : boomer} className={styles.welcomeBoomer} />
                            </div>
                            <div className={styles.boomerInfo}>
                                <h1 className={styles.boomerName}>{data.currentStudent.name}</h1>
                                <div className={styles.boomerGems}>
                                    <img src={gem} className={styles.gem} alt='gem' />
                                    <p>{data.currentStudent.availableGems} {data.currentStudent.availableGems === 1 ? 'gem' : 'gems'}</p>
                                </div>
                            </div>
                        </div>

                        <div className={styles.boomerProgress}>
                            <div className={styles.progressHeadlineWrapper}>
                                <h3 className={styles.progressHeadline}>Your Progress</h3>
                            </div>

                            <ProgressItems
                                items={[
                                    { imageSrc: progressBooksCompleted, value: data.currentStudent.booksCompleted, description: 'Books Completed' },
                                    { imageSrc: progressWinningChapters, value: data.currentStudent.winningChapters, description: 'Winning Chapters' },
                                    { imageSrc: progressGems, value: data.currentStudent.academicYearTotalGemsEarned, description: 'Gems Earned' },
                                ]}
                            />
                        </div>
                    </div>

                    <div className={styles.classProjectsPublishedBooksContainer}>
                        <div className={styles.currentClassProjects}>
                            <div className={styles.classProjTitleLinkContainer}>
                                <div className={styles.classProjectTilteContainer}>
                                    <img src={classProjects} alt='Class Projects Icon' />
                                    <h2 className={styles.classProjectsHeadline}>Current Class Projects</h2>
                                </div>

                                <Link to='/classProjects' >
                                    <div className={styles.classProjLinkContianer}>
                                        <h3 className={styles.classProjLinkTitle}>View all projects</h3>
                                        <img src={navigationIcon} alt='Navigation Icon' />
                                    </div>
                                </Link>

                            </div>
                            <ClassProjects books={getBooks('classProject')} showFirstX={2} />
                        </div>
                        <div className={styles.publishedBooks}>
                            <div className={styles.publishBooksTilteContainer}>
                                <img src={progressBooksCompleted} width={57} height={57} alt='Published Books Icon' />
                                <h4 className={styles.publishBooksHeadline}>Published Books</h4>
                            </div>
                            <PublishedBooks
                                books={getBooks('published')}
                                showFirstX={4}
                                showReadButton={true}
                            />

                            <Link to='/classPublishedBooks'>
                                <div className={styles.publishedBooksLinksContianer}>
                                    <h3 className={styles.publishedBooksLinkTitle}>View all books</h3>
                                    <img src={navigationIcon} alt='Navigation Icon' />
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                {data.currentStudent.shouldDisplaySurvey && (
                    <>
                        {data.currentStudent?.selectedBookTemplate ?
                            <div className={styles.ispBanner}>
                                <p>The book template you selected for the next part of the IPS Writing project is:</p>
                                <p className='heavy'>{data.currentStudent.selectedBookTemplate.name}</p>
                            </div>
                            :
                            data2.filteredBookTemplates?.length > 0 &&
                            <Link to='/selectStory' className={styles.ispBanner}>
                                <p>Choose your story start for the next part of the ISP Writing Project!</p>
                                <img width={240} src={ispLogo} alt='isp logo' />
                            </Link>
                        }
                    </>
                )}
            </>
        )
    }
    return null;
}

export default Dashboard;
